import Enums from 'utils/EnumsManager';

const { WorkFlow } = Enums;
const { UserInput, ContextAttributes } = WorkFlow;

class WorkFlowCriteria {
  constructor(props) {
    const {
      display_num = -1,
      function_type = '',
      function_name = '',
      valueType = UserInput,
      fieldId = '',
      value = '',
      type = '',
    } = props;

    this.fieldId = fieldId;
    this.value = value;
    this.displayNum = display_num;
    this.functionType = function_type;
    this.conditionId = function_name;
    this.valueType = valueType;
    this.type = type;
  }
}

export default WorkFlowCriteria;



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/models/WorkFlowCriteria.js